import { bindUrl, request } from "./request";
/**
 * 确认订单信息
 * POST /oil/order/confirm
 * @param {订单信息确认} bodyParams - orderConfirmReq
 */
export function confirmOrder(bodyParams) {
  return request({
    url: bindUrl("/oil/app/order/confirm", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 下订单
 * POST /oil/order/create
 * @param {下订单} bodyParams - orderCreateReq
 */
export function createOrder(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/client/order/create", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 订单详情
 * GET /oil/order/detail
 * @param {Object} queryParams
 * @param {number} queryParams.id - 订单主建id
 */
export function getOrderDetail(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/order/detail", {}),
    method: "GET",
    params: queryParams
  });
}
/**
 * 订单列表
 * GET /oil/order/list
 * @param {Object} queryParams
 * @param {number} queryParams.page - 页码
 * @param {number} queryParams.limit - 每页数量
 * @param {number} queryParams.status - 订单状态
 */
export function getOrderList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/order/list", {}),
    method: "GET",
    params: queryParams
  });
}

export function getStatistic(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/order/list/statistic", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 订单列表
 * POST GET /oil/admin/order/list
 */
export function getAdminOrderList(queryParams) {
  return request({
    //url: bindUrl("/oil/admin/order/list", {}),
    url: bindUrl("/svc-oil/admin/order/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 订单详情
 * GET /oil/admin/order/detail
 * @param {Object} queryParams
 * @param {number} queryParams.id - 订单主建id
 */
export function getAdminOrderDetail(queryParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/detail", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 下订单
 * POST /oil/order/create
 * @param {下订单} bodyParams - orderCreateReq
 */
export function followOrder(bodyParams) {
  return request({
    url: bindUrl("/oil/admin/order/follow", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 下订单
 * POST /oil/order/create
 * @param {下订单} bodyParams - orderCreateReq
 */
export function confirmAdminOrder(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/audit", {}),
    method: "POST",
    data: bodyParams
  });
}

export function addConfirmAdminOrder(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/delivery/order/create", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 下订单
 * POST /oil/admin/order/finish
 * @param {下订单} bodyParams - orderCreateReq
 */
export function finishAdminOrder(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/finish", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 身份证上传
 * POST /oil/client/idCard/upload
 * @param {ClientUploadIdCardReq} bodyParams - clientUploadIdCardReq
 */
export function getAdminOrderCount(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/status/count", {}),
    method: "POST",
    data: bodyParams
  });
}

export const getOrderRecord = request("/oil/app/order/preRecord");

/**
 * 客户获取付款方式
 */
export function orderPaymentMethod(queryParams) {
  return request({
    url: bindUrl("/svc-oil/common/payment/method/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 交易员付款方式
 */
export function adminOrderPaymentMethod(queryParams) {
  return request({
    url: bindUrl("/svc-oil/common/payment/method/list", {}),
    method: "GET",
    params: queryParams
  });
}

export function finishAdminOrderAllow(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/allow/finish", {}),
    method: "POST",
    data: bodyParams
  });
}

export function rejectAdminOrderAllow(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/follow/allowReject", {}),
    method: "POST",
    data: bodyParams
  });
}

export function adminOrderReject(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/order/follow/reject", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getNoRoleList(queryParams) {
  return request({
    url: bindUrl("/blade-user/no-role-list", {}),
    method: "GET",
    params: queryParams
  });
}

export function getCompanyList(queryParams) {
  return request({
    url: bindUrl("/svc-abns/trader/company/selectAllCompanyPage", {}),
    method: "GET",
    params: queryParams
  });
}

export function tempOrderCreate(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/admin/temp/order/create", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getTempOrderDetail(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/temp/order/detail", {}),
    method: "GET",
    params: queryParams
  });
}

export function clientOrderConfirm(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/client/order/confirm", {}),
    method: "POST",
    data: bodyParams
  });
}
